// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".css?ver=c9c7410d-bd53-412c-9c86-26b283f75ccd";
};